<template>
    <div class="content">
        <pull-to :top-load-method="downRefreshTwo" :bottom-load-method="upRefreshTwo" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0 >
            <div class="box">
                <div v-for="(item, index) in setDdatList" :key="index" class="item">
                    <!-- top -->
                    <div class="item-top">
                        <!-- left -->
                        <div>{{ item.store_name ? item.store_name : '' }}</div>
                        <!-- right -->
                        <div @click.stop="goTo(item)">导航</div>
                    </div>
                    <!-- mid -->
                    <div class="item-mid">{{ item.address ? item.address : '' }}</div>
                    <!-- bottom -->
                    <div class="item-bottom">
                        <!-- left -->
                        <div class="item-bottom-left">{{ item.juli ? item.juli : '' }}</div>
                        <!-- right -->
                        <div class="item-bottom-right" @click="phoneClick(item.store_tel)">
                            <img src="../../../../assets/images/case/phone.png" alt="">
                            <a :href="`tel:`+item.store_tel">{{ item.store_tel ? item.store_tel : '' }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </pull-to>
    </div>
</template>

<script>
import PullTo from "vue-pull-to";
import common from "@/common/common";
import {requestAesPost5} from "@/libsV2/requestAes";
import path from "@/path.js";
export default {
    components: {
        PullTo,
    },
    data() {
        return {
            nTopicId:0,//案例id
            parmse: {
                page: 0,                   // 第几页
                length: 8,                 // 一页多少数据
                longitude: '',             // 经度118.158714
                latitude: ''               // 纬度24.513086
            },
            total: 0,                      // 列表数据总条数
            setDdatList: [],               // 列表数据
        }
    },
    created() {
        let that = this;
        this.parmse.longitude = this.$storage.getStorage('objLocation')?.lng;
        this.parmse.latitude = this.$storage.getStorage('objLocation')?.lat;
        this.nTopicId=this.$route.query.topicId
        that.getDataList();
    },
    methods: {
      // 电话点击量采集
        phoneClick(phone){
          let data ={
            type:'topic',
            type_id:this.nTopicId,
            action:'click',
            element:'phone',
            element_data:JSON.stringify({phone:phone}),
            page_url:'/case/map/v2/store'
          }
          this.$store.commit("loadSwitch", true);
          requestAesPost5(path.BROWSE_STATISTICS, data).then((res) => {
            this.$store.commit("loadSwitch", false);
          });
        },
        getDataList() {
            requestAesPost5(path.GETNEARLIST,this.parmse).then( res => {
                console.log(res, '门店列表数据');
                let newArr = res.data.data.result;
                this.setDdatList = [...this.setDdatList, ...newArr.data];
                this.total = newArr.total;
            })
        },
        goTo(value) {   // 导航
            window.location.href = `https://apis.map.qq.com/uri/v1/routeplan?type=bus&from=我的位置&fromcoord=${ this.parmse.latitude },${this.parmse.longitude}&to=${ value.store_name }&tocoord=${ value.longitude },${ value.latitude }&policy=1&key=UW3BZ-J2JRA-XXIKC-CGQBX-ZC4Y6-NJFB5&referer=aosms`
        },
        //下拉
        downRefreshTwo(loaded) {
            loaded("done");
            this.parmse.page = 0;
            this.setDdatList = [];
            this.getDataList();
        },
        //上拉
        upRefreshTwo(loaded) {
            loaded("done");
            // 获取数据的总页数
             // 获取数据的总页数
            let pageSize = common.pageCount(this.total, this.parmse.length);
            if (this.parmse.page >= pageSize) return this.$toast("到底了~");
            this.parmse.page++;
            this.getDataList();
        },
    }

}
</script>

<style lang='scss' scoped>
    .content {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background: #F7F7F7;
        .box {
            padding: 28px 24px;
            .item {
                padding: 28px 24px;
                margin-top: 20px;
                background: #FFFFFF;
                border-radius: 12px;
                .item-top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    div:first-of-type {
                        font-size: 32px;
                        font-weight: 500;
                        color: #2A2A2A;

                        max-width: 500px;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                    div:last-of-type {
                        width: 120px;
                        height: 52px;
                        text-align: center;
                        line-height: 52px;
                        background: rgba(255, 255, 255, 0.68);
                        border-radius: 28px;
                        border: 2px solid rgba(49, 133, 68, 0.3);

                        font-size: 24px;
                        font-weight: 400;
                        color: #318544;
                    }
                }
                .item-mid {
                    margin-top: 12px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #959595;
                }
                .item-bottom {
                    margin-top: 28px;

                    display: flex;
                    align-content: center;
                    justify-content: space-between;
                    .item-bottom-left {
                        font-size: 24px;
                        font-weight: 400;
                        color: #959595;
                    }
                    .item-bottom-right {
                        display: flex;
                        align-items: center;

                        font-size: 28px;
                        font-weight: 400;
                        color: #3D3D3D;
                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 8px;
                        }
                        a {
                            text-decoration: none;
                            color: #3D3D3D;
                        }
                    }
                }
            }
            .item:first-of-type {
                margin-top: 0 !important;
            }
        }
    }
</style>
